import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { fetchAccount, type BillingAccount } from '../services/billing';

/**
 * 额度与套餐状态。AI 解读扣费后需要刷新，所以提供 refresh()。
 */
export function useBilling() {
  const { user } = useAuth();
  const [account, setAccount] = useState<BillingAccount | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      setAccount(await fetchAccount(user));
    } catch {
      /* 静默失败：不阻断主流程 */
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    account,
    loading,
    refresh,
    balance: account?.balance ?? null,
    isBasic: account?.plan === 'basic',
    planName: account?.planName ?? '免费',
  };
}
